// Keep in sync with MAX_IMPORT_PAGES in the backend's importDocumentSelection service.
export const MAX_IMPORT_PAGES = 8;

/** The pages one batch imported, inclusive. */
export interface ImportedPageRange {
  fromPage: number;
  toPage: number;
}

/** The first page still to import after `range`, or null once the whole document is done. */
export function nextBatchStart(
  range: ImportedPageRange | null | undefined,
  pageCount: number,
): number | null {
  if (!range) return null;
  const next = range.toPage + 1;
  return next <= pageCount ? next : null;
}
